import { motion } from "framer-motion";

const COMING = [
  "New York", "Los Angeles", "Chicago", "Miami", "Las Vegas", "New Orleans",
  "San Francisco", "Boston", "Washington DC", "Seattle", "Austin", "Nashville",
];

export default function ComingSoon() {
  return (
    <section className="border-b border-white/10 py-20" data-testid="coming-soon-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="font-mono text-xs uppercase tracking-[0.35em] text-neon-purple">03 // The Expansion</div>
          <h2 className="mt-3 font-editorial text-2xl uppercase tracking-wide sm:text-3xl lg:text-4xl">
            More cities <span className="text-neon-purple text-glow-magenta">coming soon</span>
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-zinc-400 sm:text-base">
            Philadelphia is just the first threshold. These cities are already mapped, loaded,
            and waiting for launch night.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {COMING.map((c, i) => (
              <motion.span
                key={c}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:border-neon-purple/40 hover:text-neon-purple"
                data-testid={`coming-city-${i}`}
              >
                {c} — soon
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
